var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5L1 12.5H11L10 10.5L9.6758 5.31287C9.57699 3.73176 8.26584 2.5 6.68165 2.5H5.31835C3.73416 2.5 2.42301 3.73176 2.3242 5.31287L2 10.5Z",
    stroke: "#C7A267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V1.80278C5 1.60535 5.05844 1.41234 5.16795 1.24808V1.24808C5.56377 0.654342 6.43623 0.654342 6.83205 1.24808V1.24808C6.94156 1.41234 7 1.60535 7 1.80278V3",
    stroke: "#C7A267",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13V13.3333C5 13.5497 5.07018 13.7602 5.2 13.9333V13.9333C5.6 14.4667 6.4 14.4667 6.8 13.9333V13.9333C6.92982 13.7602 7 13.5497 7 13.3333V13",
    stroke: "#C7A267",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.c4c69b7ba92a439a91e7052743321405.svg";
export { ForwardRef as ReactComponent };